import { del, get, post, put } from "../axios";
import { simpleResponse } from "./api-helpers";
import { responseIsSuccessful } from "../global-helpers";

export async function getAllScopeItems() {
  return await get("work-scope-items", window.localStorage.apiToken)
    .then(res => {
      if (responseIsSuccessful(res) && res.data.scope_items) {
        return res.data.scope_items;
      }
      return [];
    })
    .catch(err => {
      console.log(err);
      return [];
    });
}

export async function storeScopeItem(scopeItem) {
  return await simpleResponse(
    post(
      "work-scope-items",
      { scope_item_params: scopeItem },
      window.localStorage.apiToken
    )
  );
}

export async function updateScopeItem(scopeItem) {
  return await simpleResponse(
    put(
      `work-scope-items/${scopeItem.id}`,
      { scope_item_params: scopeItem },
      window.localStorage.apiToken
    )
  );
}

export async function deleteScopeItem(scopeItem) {
  return await simpleResponse(
    del(`work-scope-items/${scopeItem.id}`, window.localStorage.apiToken)
  );
}
